import { Hex } from 'js/bubbleCore/Hex';
import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop';

const tempHexes = Hex.getTempHexes();

export function pxToSpacePosition(
  x: number,
  y: number,
  {width, height, type, size}: IHexPixelSize,
  out?: PIXI.Point,
): PIXI.Point {
  const result = out || new PIXI.Point();
    let q: number;
    let r: number;

    const properX = x - (width * 0.5);
    const properY = y - (height * 0.5);

    if (isPointyTop(type)) {
      q = (properX * Math.sqrt(3)/3 - properY / 3) / size;
      r = properY * 2/3 / size;
    } else {
      q = properX * 2/3 / size;
      r = (-properX / 3 + Math.sqrt(3)/3 * properY) / size;
    }

    return tempHexes[type].setAxial(q, r).getPosition(out);
}